import { render, staticRenderFns } from "./pageCourseOptions.vue?vue&type=template&id=3858c6fc&"
import script from "./pageCourseOptions.vue?vue&type=script&lang=js&"
export * from "./pageCourseOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports